import { ICompactProduct } from "api/interfaces/get-page-details/common/CompactProduct.type";
import { IProductReview, IRatingSnapShot } from "api/interfaces/product-review.type";
import StarRatings from "component/design-system/StarRatings";
import PAText, {
  FONT_SIZE,
} from "component/design-system/typography/PAText/PAText";
import Text from "component/design-system/typography/Text";
import ProgressiveBar from "component/progressiveBar/ProgressiveBar";
import Price from "modules/components/prices/price/Price";
import BottomSheetWrapper from "modules/modals/BottomSheetWrapper";
import HideIf from "util/HideIf";
import { getThumbmailSrc } from "../../../../../util/product/getThumbmailSrc";
import PAImage from "../../../../design-system/images/PAImage";
import SingleReviewCard from "../SingleReviewCard";
import reviewsStyles from "../productReviews.module.scss";
import styles from "./mobileSeeAllReviewsModal.module.scss";

interface IProps {
  product: ICompactProduct;
  reviews: IProductReview[];
  totalReviewsCount: number;
  averageRating: number;
  ratingSnapShot: IRatingSnapShot[];
  setMobilePage: (page: number) => void;
  mobilePage: number;
  onHide: () => void;
  totalPages: number;
  handleEditReview: () => void;
}

const MobileSeeAllReviewsModal = ({
  product,
  onHide,
  reviews,
  totalReviewsCount,
  averageRating,
  ratingSnapShot,
  setMobilePage,
  totalPages,
  mobilePage,
  handleEditReview,
  postDeleteReview,
}: IProps) => {
  const handleSeeMore = () => {
    setMobilePage(mobilePage + 1);
  };

  return (
    <BottomSheetWrapper title="Reviews" onHide={onHide}>
      <div className={styles.mobile_reviews_container}>
        <div className={styles.product_description}>
          <div className={`${styles.product_image_container}`}>
            <PAImage
              src={getThumbmailSrc(product)}
              width={120}
              height={120}
              lazyLoad={false}
            />
          </div>

          <div>
            <Text size={4} bold>
              {product.description}
            </Text>

            <Text size={6} bold>
              by
              {" "}
              {product.manufacturer}
            </Text>

            <Price {...{ product }} className="padding-right" />
          </div>
        </div>

        <>
          <div
            className={`${reviewsStyles.review_product_container} ${reviewsStyles.mobile_review_product_container} ${styles.mobile_reviews_container}`}
          >
            <div className={reviewsStyles.star_container}>
              <PAText inlineBlock className={reviewsStyles.average_rating}>
                {averageRating.toFixed(1)}
              </PAText>
              <StarRatings
                rating={averageRating}
                filled
                className="fa-2x"
              />
              <PAText color="grey">
                {`${totalReviewsCount} review${
                totalReviewsCount > 1 ? "s" : ""
              }`}
              </PAText>
            </div>

            <div className={reviewsStyles.rating_snapshot}>
              <PAText fontSize={FONT_SIZE[2]} className="m-t-5">
                Rating Snapshot
              </PAText>
              {[...ratingSnapShot].reverse().map(({ count }, i) => (
                <div key={i} className={reviewsStyles.progressive_bar_container}>
                  <i className="fa fa-star m-r-5" />
                  <PAText className="m-r-20" fontSize={FONT_SIZE[2]}>
                    {5 - i}
                  </PAText>
                  <ProgressiveBar
                    current={count}
                    total={totalReviewsCount}
                    className={reviewsStyles.progressive_bar}
                  />
                  <PAText color="grey">{count.toFixed()}</PAText>
                </div>
              ))}
            </div>
            {reviews.map((review: IProductReview) => (
              <SingleReviewCard
                key={review?.reviewId}
                review={review}
                className={styles.mobile_reviews_list}
                handleEditReview={() => handleEditReview(review)}
                postDeleteReview={postDeleteReview}
              />
            ))}
          </div>
        </>

        <HideIf show={(mobilePage + 1) < (totalPages)}>
          <div className={reviewsStyles.see_more_reviews} onClick={handleSeeMore}>
            <PAText color="success-secondary" fontSize={FONT_SIZE[2]}>
              See more reviews
            </PAText>
          </div>
        </HideIf>
      </div>
    </BottomSheetWrapper>
  );
};

export default MobileSeeAllReviewsModal;
